import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["progressBar", "progressLabel", "addonCard", "sectionContainer"]
  static values = { opportunityId: String, completionPercent: Number }

  connect() {
    document.addEventListener("opp-editor:saved", this.handleSectionSaved.bind(this))
  }

  disconnect() {
    document.removeEventListener("opp-editor:saved", this.handleSectionSaved.bind(this))
  }

  handleSectionSaved(event) {
    const completion = event.detail?.completion
    if (completion && completion.overall_percent !== undefined) {
      this.updateProgress(completion.overall_percent)
    }
  }

  updateProgress(percent) {
    this.completionPercentValue = percent
    if (this.hasProgressBarTarget) {
      this.progressBarTarget.style.width = `${percent}%`
      this.progressBarTarget.setAttribute("aria-valuenow", percent)
    }
    if (this.hasProgressLabelTarget) {
      this.progressLabelTarget.textContent = `${percent}% complete`
    }
  }

  helpMeSetUp() {
    // Find the assistant chat controller and send a suggested message
    const assistantEl = document.querySelector('[data-controller~="assistant-chat"]')
    if (assistantEl) {
      const controller = this.application.getControllerForElementAndIdentifier(assistantEl, 'assistant-chat')
      if (controller) {
        controller.sendSuggestedMessage(
          "Help me set up this event. What information do I need to provide?"
        )
        return
      }
    }
    // Fallback: just toggle the panel
    const toggleBtn = document.querySelector('.assistant-toggle-button')
    if (toggleBtn) toggleBtn.click()
  }

  toggleSection(event) {
    const sectionId = event.currentTarget.dataset.section
    const wrapper = document.getElementById(`section-${sectionId}-wrapper`)
    if (wrapper) {
      wrapper.classList.remove("d-none")
      wrapper.scrollIntoView({ behavior: "smooth", block: "start" })
    }
    // Hide the addon card that was clicked
    const card = event.currentTarget.closest(".col-md-4")
    if (card) card.remove()

    // Hide the "Add Features" heading if no more cards
    const grid = document.querySelector(".row.g-3.mb-4")
    if (grid && grid.querySelectorAll(".col-md-4").length === 0) {
      const heading = grid.previousElementSibling
      if (heading && heading.tagName === "H4") heading.remove()
      grid.remove()
    }
  }
}
